import {
    useSourceIdCookie,
} from '../useContentReplacers/contentReplacers/sourceid/useSourceIdCookie';
import constructSourceId from '../useContentReplacers/contentReplacers/sourceid/constructSourceId';
import { replaceLearningCenterSourceIdHash } from '../useContentReplacers/contentReplacers/sourceid/learningCenterSourceId';
import { DEFAULT_ORIGIN } from './Constants';

const getContextualSourceId = ({
    articleId,
    suffix
}) =>
{
    const sourceIdCookie = useSourceIdCookie();
    const { location } = sourceIdCookie;
    let { sourceid:contextualSourceId } = sourceIdCookie;
    if ( !contextualSourceId )
    {
        contextualSourceId = 
            ( articleId ) ?
            replaceLearningCenterSourceIdHash( {
                url: new URL( `#sourceid-${suffix}`, location?.origin ?? DEFAULT_ORIGIN ),
                articleId
            }) :
            constructSourceId( location, suffix )
    }
    return contextualSourceId;
}
export default getContextualSourceId;
